import React from "react"
import parentStyles from "../styles.css"
import styles from "./styles.css"
import PropTypes from "prop-types"

const TextArea = ({ formik, formValues }) => {
  const { name, placeholder, limit } = formValues
  const { touched, values, errors, handleBlur, handleChange } = formik
  const isErrorField = touched[name] && errors[name]

  const quantifyOfChars = values[name] ? values[name].length : 0

  return (
    <div>
      <div className={styles.text_area}>
        <textarea
          name={name}
          className={`${isErrorField && styles.focus_error}`}
          placeholder={placeholder}
          rows={5}
          maxLength={limit}
          value={values[name]}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
      <div className={`${styles.limit} ${isErrorField && parentStyles.error}`}>
        {quantifyOfChars}/{limit}
        {isErrorField && (
          <span className={parentStyles.error}>{errors[name]}</span>
        )}
      </div>
    </div>
  )
}

TextArea.propTypes = {
  formik: PropTypes.object,
  formValues: PropTypes.object
}

export default TextArea



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/TextArea/index.js